import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Box,
  IconButton,
  Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import "./CommonDialog.css"
import Draggable from 'react-draggable';

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds="parent"
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

export default function CommonDialog({ open, onClose, title, children, hideBackDrop, width}) {
  const [content, action] = React.Children.toArray(children);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      hideBackdrop ={hideBackDrop}
      disableEnforceFocus
      disableAutoFocus
      disableRestoreFocus
      sx={
        hideBackDrop
          ? {
            pointerEvents: 'none',
            '& .MuiDialog-paper': {
              pointerEvents: 'auto',
            },
            cursor: 'move'
          }
          : ''
      }
     {...(hideBackDrop ? { PaperComponent: PaperComponent } : {})}
      PaperProps={{
        sx: width ? { width: width, maxWidth: 'none' } : {},
      }}
    >
      <DialogTitle id="draggable-dialog-title" className='CommonDialogTitle'>
        <Box>{title}</Box>
        <IconButton onClick={onClose} size="small"  edge="end" aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>      
      <DialogContent dividers className='CommonDialogContent'>
        {content}
      </DialogContent>      
      <DialogActions className='CommonDialogActions'>
        {action}
      </DialogActions>       
    </Dialog>
  );
}
